import { InterventionCard } from '../../interventions/InterventionCard';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';
import { sortSelectedInterventions, type ExistingInterventionState } from '../reducer/wizardReducer';
import { CustomInterventionForm } from './CustomInterventionForm';
import { NewPredefinedInterventionForm } from './NewPredefinedInterventionForm';

export function CaptureInterventionDetailsStep() {
	const { wizardState } = useGoalsAndInterventionsWizard();

	const newInterventions = wizardState.selectedInterventions.filter(x => x.type === 'predefined' || x.type === 'custom');
	const existingInterventions: ExistingInterventionState[] = wizardState.selectedInterventions.filter(x => x.type === 'existing');
	return (
		<div className="flex flex-col gap-8">
			<div className="flex flex-col gap-4">
				<span>New Interventions </span>
				{sortSelectedInterventions(newInterventions).map(x => {
					if (x.type === 'predefined') {
						return <NewPredefinedInterventionForm key={x.id} intervention={x} />;
					} else if (x.type === 'custom') {
						return <CustomInterventionForm key={x.id} intervention={x} />;
					}

					return null;
				})}
			</div>
			{existingInterventions.length > 0 && (
				<div className="flex flex-col gap-4">
					<span>Existing Interventions </span>
					{sortSelectedInterventions(existingInterventions).map((x: ExistingInterventionState) => (
						<InterventionCard
							key={x.id}
							interventionDefinition={
								x.existingIntervention.interventionDefinition
									? {
											...x.existingIntervention.interventionDefinition,
											title: x.existingIntervention.title,
											definitionText: x.existingIntervention.definitionText
									  }
									: {
											title: x.existingIntervention.title,
											definitionText: x.existingIntervention.definitionText,
											documentationWorkflows: [],
											restrictedToClinicalTypes: []
									  }
							}
						/>
					))}
				</div>
			)}
		</div>
	);
}
